import store from '@state/store'

export default [
  {
    path: '/',
    redirect: '/dashboard',
    name: 'home',
    component: () => lazyLoadView(import('@views/home')),
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    component: () => lazyLoadView(import('@views/home')),
  },

  // === CMS ===

  // -- PAGES

  {
    path: '/content/pages',
    name: 'contentPages',
    component: () => lazyLoadView(import('@views/cms/pages/main')),
  },
  {
    path: '/content/pages/create',
    name: 'contentPagesCreate',
    component: () => lazyLoadView(import('@views/cms/pages/page-edit')),
  },
  {
    path: '/content/pages/edit/:id?',
    name: 'contentPagesEdit',
    component: () => lazyLoadView(import('@views/cms/pages/page-edit')),
  },

  // -- ARTICLES

  {
    path: '/content/articles',
    name: 'contentArticles',
    component: () => lazyLoadView(import('@views/cms/articles/main')),
  },
  {
    path: '/content/articles/create',
    name: 'contentArticlesCreate',
    component: () => lazyLoadView(import('@views/cms/articles/article-edit')),
  },
  {
    path: '/content/articles/edit/:id?',
    name: 'contentArticlesEdit',
    component: () => lazyLoadView(import('@views/cms/articles/article-edit')),
  },

  // -- GALLERY

  {
    path: '/content/gallery',
    name: 'contentGallery',
    component: () => lazyLoadView(import('@views/cms/gallery/main')),
  },
  {
    path: '/content/gallery/edit/:id?',
    name: 'contentGalleryEdit',
    component: () => lazyLoadView(import('@views/cms/gallery/album-edit')),
  },

  // === SETTINGS ===

  // -- CLASSES
  {
    path: '/setting/classes',
    name: 'settingClasses',
    component: () => lazyLoadView(import('@views/setting/classes/main')),
  },
  {
    path: '/setting/classes/create',
    name: 'settingClassesCreate',
    component: () => lazyLoadView(import('@views/setting/classes/class-edit')),
  },
  {
    path: '/setting/classes/edit/:id?',
    name: 'settingClassesEdit',
    component: () => lazyLoadView(import('@views/setting/classes/class-edit')),
  },

   // -- ROLES

  {
    path: '/setting/rolesAndPermissions',
    name: 'settingRolesAndPermissions',
    component: () => lazyLoadView(import('@views/setting/rolesAndPermissions/main')),
  },

  {
    path: '/setting/rolesAndPermissions/edit/:id?',
    name: 'settingRolesAndPermissionsEdit',
    component: () => lazyLoadView(import('@views/setting/rolesAndPermissions/role-edit')),
  },


  // -- USERS

  {
    path: '/setting/users',
    name: 'settingUsers',
    component: () => lazyLoadView(import('@views/setting/users/main')),
  },

  {
    path: '/setting/users/edit/:id?',
    name: 'settingUsersEdit',
    component: () => lazyLoadView(import('@views/setting/users/user-edit')),
  },

  
  // -- NAVIGATION

  {
    path: '/setting/navigation',
    name: 'settingNavigation',
    component: () => lazyLoadView(import('@views/setting/navigation/main')),
  },

  {
    path: '/setting/navigation/menu/edit/:id?',
    name: 'settingNavigationMenuEdit',
    component: () => lazyLoadView(import('@views/setting/navigation/menu-edit')),
  },


  // === SYSTEM ===

  {
    path: '/system/jobs',
    name: 'systemJobs',
    component: () => lazyLoadView(import('@views/system/jobs/main')),
  },
  {
    path: '/system/logs',
    name: 'systemLogs',
    component: () => lazyLoadView(import('@views/system/logs/main')),
  },
  {
    path: '/system/settings',
    name: 'systemSettings',
    component: () => lazyLoadView(import('@views/system/settings/main')),
  },
  {
    path: '/system/systeminfo',
    name: 'systemInfo',
    component: () => lazyLoadView(import('@views/system/systemInfo/main')),
  },

  // === COMMONN ===

  {
    path: '/login',
    name: 'login',
    component: () => lazyLoadView(import('@views/login')),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters['auth/loggedIn']) {
          // Redirect to the home page instead
          next({ name: 'home' })
        } else {
          // Continue to the login page
          next()
        }
      },
    },
  },
  {
    path: '/profile',
    name: 'profile',
    component: () => lazyLoadView(import('@views/profile')),
    meta: {
      authRequired: true,
    },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
  {
    path: '/profile/:username',
    name: 'username-profile',
    component: () => lazyLoadView(import('@views/profile')),
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        store
          // Try to fetch the user's information by their username
          .dispatch('users/fetchUser', { username: routeTo.params.username })
          .then((user) => {
            // Add the user to the route params, so that it can
            // be provided as a prop for the view component below.
            routeTo.params.user = user
            // Continue to the route.
            next()
          })
          .catch(() => {
            // If a user with the provided username could not be
            // found, redirect to the 404 page.
            next({ name: '404', params: { resource: 'User' } })
          })
      },
    },
    // Set the user from the route params, once it's set in the
    // beforeResolve route guard.
    props: (route) => ({ user: route.params.user }),
  },
  {
    path: '/logout',
    name: 'logout',
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        store.dispatch('auth/logOut')
        const authRequiredOnPreviousRoute = routeFrom.matched.some(
          (route) => route.meta.authRequired
        )
        // Navigate back to previous page, or home as a fallback
        next(authRequiredOnPreviousRoute ? { name: 'home' } : { ...routeFrom })
      },
    },
  },
  {
    path: '/404',
    name: '404',
    component: require('@views/_404').default,
    // Allows props to be passed to the 404 page through route
    // params, such as `resource` to define what wasn't found.
    props: true,
  },
  // Redirect any unmatched routes to the 404 page. This may
  // require some server configuration to work in production:
  // https://router.vuejs.org/en/essentials/history-mode.html#example-server-configurations
  {
    path: '*',
    redirect: '404',
  },
]

// Lazy-loads view components, but with better UX. A loading view
// will be used if the component takes a while to load, falling
// back to a timeout view in case the page fails to load. You can
// use this component to lazy-load a route with:
//
// component: () => lazyLoadView(import('@views/my-view'))
//
// NOTE: Components loaded with this strategy DO NOT have access
// to in-component guards, such as beforeRouteEnter,
// beforeRouteUpdate, and beforeRouteLeave. You must either use
// route-level guards instead or lazy-load the component directly:
//
// component: () => import('@views/my-view')
//
function lazyLoadView(AsyncView) {
  const AsyncHandler = () => ({
    component: AsyncView,
    // A component to use while the component is loading.
    loading: require('@views/_loading').default,
    // Delay before showing the loading component.
    // Default: 200 (milliseconds).
    delay: 400,
    // A fallback component in case the timeout is exceeded
    // when loading the component.
    error: require('@views/_timeout').default,
    // Time before giving up trying to load the component.
    // Default: Infinity (milliseconds).
    timeout: 10000,
  })

  return Promise.resolve({
    functional: true,
    render(h, { data, children }) {
      // Transparently pass any props or children
      // to the view component.
      return h(AsyncHandler, data, children)
    },
  })
}
